import { Sparkles } from 'lucide-react';
import { PageHeader } from '@/components/common/PageHeader';
import { EmptyState } from '@/components/common/states';

/** Placeholder for routes whose feature module is scheduled for a later phase. */
export function ComingSoonPage({ title, note }: { title: string; note?: string }) {
  return (
    <div className="space-y-6">
      <PageHeader title={title} description="Planned module — not yet wired to the backend." />
      <EmptyState
        icon={Sparkles}
        title={`${title} is coming soon`}
        description={
          note ??
          'This screen is part of the enterprise roadmap. It will light up once its backend endpoints land.'
        }
      />
    </div>
  );
}

export default ComingSoonPage;
